import { Stack, Typography } from "@altimateai/lego";

const SavingsEmptyState = () => (
  <Stack
    direction="column"
    align="center"
    justify="center"
    className="al-w-full al-min-h-[280px] al-px-8 al-py-12 al-bg-slate-50 al-rounded-xl al-border al-border-dashed al-border-slate-200"
  >
    <Stack
      align="center"
      justify="center"
      className="al-w-16 al-h-16 al-mb-4 al-rounded-full al-bg-teal-50"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#01CD8C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    </Stack>
    <Typography variant="body" className="al-mb-2 al-font-semibold al-text-slate-800">
      No Savings Yet
    </Typography>
    <Typography
      variant="caption"
      className="al-max-w-[360px] al-text-center al-text-slate-500 al-leading-snug"
    >
      Savings are generated when you implement optimization opportunities like rightsizing oversized
      clusters and fixing high-failure jobs.
    </Typography>
  </Stack>
);

export default SavingsEmptyState;
